module.exports = __webpack_public_path__ + "static/media/user2.50e882d6.jpg";